export enum ReceiptTextSize {
  STANDARD = "STANDARD",
  LARGE = "LARGE",
  SMALL = "SMALL",
}
